import type { PixiPaymentMethod } from "../../../hooks/usePixiWizardState";
import { CardForm } from "../CardForm";
import { PaymentMethodPicker } from "../PaymentMethodPicker";
import { InvoiceNotice } from "./InvoiceNotice";
import { SectionCard } from "./SectionCard";

export interface PaymentSectionProps {
  paymentMethod: PixiPaymentMethod;
  onSelectMethod: (method: PixiPaymentMethod) => void;
  /** Reports the Stripe paymentMethod id once the card is tokenized, else null. */
  onCardPaymentMethodChange: (id: string | null) => void;
}

/**
 * Payment method picker plus the selected method's body: the credit-card fields
 * (Credit card) or an informational notice (Invoice). The Stripe `Elements`
 * provider is owned by the parent step, so this stays a presentational section.
 */
export function PaymentSection({
  paymentMethod,
  onSelectMethod,
  onCardPaymentMethodChange,
}: PaymentSectionProps) {
  return (
    <SectionCard testId="payment-card">
      <PaymentMethodPicker selected={paymentMethod} onSelect={onSelectMethod} />
      {paymentMethod === "credit_card" && (
        <CardForm onPaymentMethodChange={onCardPaymentMethodChange} />
      )}
      {paymentMethod === "invoice" && <InvoiceNotice />}
    </SectionCard>
  );
}
